import cn from 'classnames';
import React from 'react';
import { Text } from 'src/components/text/Text';

import { Icon } from '../icon';
import { type IconProps } from '../icon/icon';
import styles from './TrustBanner.css';

interface Props {
  title: string;
  description: string;
  icon: IconProps['name'];
  className?: string;
  iconClassName?: string;
}

export const TrustBanner = ({
  className,
  title,
  description,
  icon,
  iconClassName,
}: Props) => {
  return (
    <div
      className={cn(styles.TrustBanner, className)}
      data-test="popup-trust-banner"
    >
      <span className={cn(styles.TrustBanner__Icon, iconClassName)}>
        <Icon name={icon} />
      </span>
      <div className={styles.TrustBanner__Content}>
        <Text
          as="p"
          variant="body1TightBold"
          data-test="popup-trust-banner-title"
        >
          {title}
        </Text>
        <Text
          as="p"
          variant="body2Tight"
          className={styles.TrustBanner__Description}
          data-test="popup-trust-banner-description"
        >
          {description}
        </Text>
      </div>
    </div>
  );
};
